import { i18n } from '../../../../shared/i18n/i18n.js'

import { formatProductPrice }    from '../../../../shared/utils/index.js'

import { DATA_ITEMS_IDS }   from '../../constants/catalogDataDisplay.js';

import { PriceBlock }            from '../../../../shared/ui/PriceBlock/index.js'
import { StatusBadge }           from '../../../../shared/ui/StatusBadge/index.js'


export const CARD_UI_MAP = { //TODO: should this use DATA_ITEMS_IDS or PRODUCT_ATTRIBUTE_IDS directly????
  [DATA_ITEMS_IDS.STATUS]: {
    cellClass: 'cellStatus',
    render: (p) => <StatusBadge status={p.status ?? 'unknown'} size="small" />,
  },

  [DATA_ITEMS_IDS.PRICE]: {
    cellClass: 'cellPrice',
    render: (p, context) => {
      const priceData = formatProductPrice(p, context?.pricesVisibility)
      if (priceData.isHidden) return (
        <em className={context.priceHiddenClass}>{i18n.t('catalog.price_hidden')}</em>
      ); //TODO centralize price formatting for hidden and null/falsy values
      return <PriceBlock 
        {...priceData}
        label={i18n.t('catalog.col_price')} 
        // className={context.priceBlockClass}
        highlight={true} 
        />
    },
  },
}
